import React from "react";
import "./Digital.css";

const digitals = [
  {
    icon: "📇",
    title: "Not getting enough orders?",
    description:
      "You work hard to promote your business, but orders stay slow. Customers are searching, yet somehow they’re not finding you.",
  },
   {
    icon: "📊",
    title: "Missing genuine leads?",
    description:
      "People show interest in your product or service, but many leads disappear before you can turn them into real customers.",
  },
  {
    icon: "💸",
    title: "Paying high commissions to middlemen?",
    description:
      "You put in the effort to run the business, but platforms and middlemen take a big share of every order.",
  },
  {
    icon: "🕐",
    title: "Losing customers due to late replies?",
    description:
      "A customer sends a message when you’re busy. By the time you reply, they’ve already chosen another business.",
  }, 
  {
    icon: "🔄",
    title: "Managing business on too many platforms?",
    description:
      "Orders on WhatsApp, products on Instagram, details on your website. Everything feels scattered and difficult to manage",
  },
   {
    icon: "🌐",
    title: " No clear view of your sales?",
    description:
      "You’re making sales, but you don’t know which product, campaign, or channel is actually bringing the most customers.",
  },
];

export default function Digital() {
  return (
    <section className="digital-section mainclass">
      <div className="digital-container maxwidth">
        <p className="digital-eyebrow">THE Challenge</p>
        <h2 className="digital-heading heading">
         Customers Are Looking for You,
          <br />
           But Can’t Find You
        </h2>
        <p className="digital-subtext">
          You’re trying to grow your business, but outdated methods can make it harder than it should be. Here’s where you might be losing opportunities:
        </p>

        <div className="digital-grid">
          {digitals.map((item, index) => (
            <div className="digital-card" key={index}>
              <div className="digital-icon">{item.icon}</div>
              <h3 className="digital-card-title">{item.title}</h3>
              <p className="digital-card-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
